import { render, staticRenderFns } from "./DetailsTitle.vue?vue&type=template&id=500e930f&scoped=true"
import script from "./DetailsTitle.vue?vue&type=script&lang=js"
export * from "./DetailsTitle.vue?vue&type=script&lang=js"
import style0 from "./DetailsTitle.vue?vue&type=style&index=0&id=500e930f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e930f",
  null
  
)

export default component.exports